import React, { useEffect, useState, useRef, useCallback } from "react";
import { scroller } from "react-scroll";
import "../css/reset.css";
import "../css/header.css";
import Logo from "../img/common/datafive_logo.png";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";
import { Link as Navi, useLocation, useNavigate } from "react-router-dom";

ChannelService.loadScript();
ChannelService.boot({
  pluginKey: "94596b74-eb76-4925-8600-2b217d4457d0",
});

const Header = () => {
  const sectionRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("");

  const navOff = () => {
    var nav = document.querySelector(".header_tablet_phone .header_nav_wrap");
    nav.classList.remove("on");
  };

  const handleNavigateAndScroll = (target, offset) => {
    if (location.pathname !== "/") {
      navigate(`/#${target}`);
    } else {
      scroller.scrollTo(target, {
        spy: true,
        smooth: true,
        offset: offset,
        duration: 500,
      });
    }
    navOff();
  };

  const handleClickOutside = useCallback((event) => {
    if (sectionRef.current && !sectionRef.current.contains(event.target)) {
      navOff();
    }
  }, []);

  useEffect(() => {
    const eventName = "ontouchstart" in window ? "touchstart" : "click";
    document.addEventListener(eventName, handleClickOutside);
    return () => {
      document.removeEventListener(eventName, handleClickOutside);
    };
  }, [handleClickOutside]);

  const activeStyle = {
    color: "#4E4E4E",
    fontSize: "20px",
    fontWeight: "600",
    lineHeight: "normal",
    letterSpacing: "-0.5px",
    cursor: "pointer",
  };

  const [position, setPosition] = useState(0);

  const onScroll = useCallback(() => {
    setPosition(window.scrollY);
    if (location.pathname === "/") {
      const scrollSections = [
        "appSection",
        "serviceSection",
        "processSection",
        "aboutSection",
        "companySection",
      ];
      const scrollPosition = window.scrollY;
      let newActiveSection = "appSection";
      const activationOffset = 200;

      for (const sectionId of scrollSections) {
        const element = document.getElementById(sectionId);
        if (element) {
          if (element.offsetTop <= scrollPosition + activationOffset) {
            newActiveSection = sectionId;
          }
        }
      }
      setActiveSection(newActiveSection);
    } else {
      setActiveSection("");
    }
  }, [location.pathname]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    onScroll(); // Initial check
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [onScroll]);

  const navOn = () => {
    var nav = document.querySelector(".header_tablet_phone .header_nav_wrap");
    nav.classList.add("on");
  };

  return (
    <>
      <section
        ref={sectionRef}
        className="header_wrap"
        style={{
          boxShadow:
            position === 0 ? "none" : "0px 5px 10px 0px rgba(0, 0, 0, 0.15)",
        }}
      >
        <div className="header_inner">
          <div className="header_web">
            <div className="header_logo_wrap">
              <button
                onClick={() => handleNavigateAndScroll("appSection", -150)}
              >
                <img src={Logo} alt="logo" />
              </button>
            </div>
            <div className="header_gnb_wrap">
              <ul>
                <li
                  style={activeStyle}
                  className={
                    location.pathname === "/" &&
                    activeSection === "serviceSection"
                      ? "active"
                      : ""
                  }
                >
                  <span
                    onClick={() =>
                      handleNavigateAndScroll("serviceSection", -80)
                    }
                  >
                    Service
                  </span>
                </li>
                <li
                  style={activeStyle}
                  className={
                    location.pathname === "/" &&
                    activeSection === "processSection"
                      ? "active"
                      : ""
                  }
                >
                  <span
                    onClick={() =>
                      handleNavigateAndScroll("processSection", -120)
                    }
                  >
                    Process
                  </span>
                </li>
                <li
                  style={activeStyle}
                  className={location.pathname === "/portfolio" ? "active" : ""}
                >
                  <Navi
                    to="/portfolio"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    Portfolio
                  </Navi>
                </li>
                <li
                  style={activeStyle}
                  className={
                    location.pathname === "/" && activeSection === "aboutSection"
                      ? "active"
                      : ""
                  }
                >
                  <span
                    onClick={() =>
                      handleNavigateAndScroll("aboutSection", -120)
                    }
                  >
                    About
                  </span>
                </li>
                <li
                  style={activeStyle}
                  className={
                    location.pathname === "/" &&
                    activeSection === "companySection"
                      ? "active"
                      : ""
                  }
                >
                  <span
                    onClick={() =>
                      handleNavigateAndScroll("companySection", -120)
                    }
                  >
                    Company
                  </span>
                </li>
                <li
                  style={activeStyle}
                  className={location.pathname === "/contact" ? "active" : ""}
                >
                  <Navi
                    to="/contact"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <span>Contact</span>
                  </Navi>
                </li>
              </ul>
            </div>
          </div>

          <div className="header_tablet_phone">
            <div className="header_logo_wrap">
              <button
                onClick={() => handleNavigateAndScroll("appSection", -150)}
              >
                <img src={Logo} alt="navOff" />
              </button>
            </div>

            <button className="menu_bar" onClick={navOn}></button>

            <div className="header_nav_wrap">
              <button
                className="header_nav_close_btn"
                onClick={navOff}
              ></button>
              <ul>
                <li
                  className={
                    location.pathname === "/" && activeSection === "appSection"
                      ? "active"
                      : ""
                  }
                >
                  <button
                    className="header_home"
                    onClick={() => handleNavigateAndScroll("appSection", -150)}
                  >
                    <span></span>Home
                  </button>
                </li>
                <li
                  style={activeStyle}
                  className={
                    location.pathname === "/" &&
                    activeSection === "serviceSection"
                      ? "active"
                      : ""
                  }
                >
                  <button
                    onClick={() =>
                      handleNavigateAndScroll("serviceSection", -50)
                    }
                  >
                    Service
                  </button>
                </li>
                <li
                  style={activeStyle}
                  className={
                    location.pathname === "/" &&
                    activeSection === "processSection"
                      ? "active"
                      : ""
                  }
                >
                  <button
                    onClick={() =>
                      handleNavigateAndScroll("processSection", -90)
                    }
                  >
                    Process
                  </button>
                </li>
                <li
                  style={activeStyle}
                  className={location.pathname === "/portfolio" ? "active" : ""}
                >
                  <Navi to="/portfolio" onClick={navOff}>
                    <button>Portfolio</button>
                  </Navi>
                </li>
                <li
                  style={activeStyle}
                  className={
                    location.pathname === "/" && activeSection === "aboutSection"
                      ? "active"
                      : ""
                  }
                >
                  <button
                    onClick={() => handleNavigateAndScroll("aboutSection", -90)}
                  >
                    About
                  </button>
                </li>
                <li
                  style={activeStyle}
                  className={
                    location.pathname === "/" &&
                    activeSection === "companySection"
                      ? "active"
                      : ""
                  }
                >
                  <button
                    onClick={() =>
                      handleNavigateAndScroll("companySection", -90)
                    }
                  >
                    Company
                  </button>
                </li>
                <li
                  style={activeStyle}
                  className={location.pathname === "/contact" ? "active" : ""}
                >
                  <Navi to="/contact" onClick={navOff}>
                    <button>Contact</button>
                  </Navi>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Header;